import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { InquiryResponse } from '@models/inquiry';
import dayjs from 'dayjs';

import styles from './styles.module.scss';

interface Props {
    inquiry: InquiryResponse;
}

function InquiryContent({ inquiry }:Props) {
  const { content, createdAt, fileUrls } = inquiry;
  return (
        <section className={styles.container}>
            <Text color={colors.gray7} className={styles.content}>
                {content}
            </Text>
            {(fileUrls && fileUrls.length !== 0) && (
                <Images>
                    {fileUrls?.map((fileUrl) => (
                        <Image src={fileUrl}
                               key={fileUrl} />
                    ))}
                </Images>
            )}
            <Row fullWidth justify='flex-end' className={styles.createdAt}>
                <Text color={colors.gray6}>
                    {dayjs(createdAt).format('YYYY.MM.DD HH:mm')}
                </Text>
            </Row>
        </section>
  );
}

const Images = styled.div`
    margin-top: 12px;
    img {
        max-width: 100%;
    }
`;

export default InquiryContent;
